import styled from 'styled-components';
import img from '../../assets/hero-bg-2.jpg';

export const MainWrapper = styled('div')`
`;

export const Blob = styled('img')`
position: absolute;
/* top: -10%; */
bottom: 0;
z-index: 999;
/* height: 1000px; */
/* background: red; */
/* left: -50%; */
width: 110vw;
opacity: 30%;
/* width: 4000px; */
/* max-height: 600px; */
`;

export const Hero = styled('div')`
    background: url(${img}) no-repeat center center / cover;
    width: 100vw;
    opacity: 60%;
    border-radius: 0% 100% 18% 82% / 67% 0% 100% 33%;
    /* max-height: 1000px; */
    position: relative;
    min-height: 600px;
    -js-display: flex;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    /* height: 100%; */
    /* width: 100%; */
`;